import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Role } from "@/store";
import { requireRoles } from "@/utils/requiredRoles";

export const Route = createFileRoute("/_private/dashboard/_base/pedidos/cadastrar")({
  component: Outlet,
  beforeLoad: requireRoles({ allowed: [Role.Administrador, Role.Usuario] })
});
